import React from 'react';
import { BookOpen, ExternalLink, ShoppingCart } from 'lucide-react';

const Libros = () => {
  const librosLuis = [
    {
      title: "El ADN del nuevo abogado",
      author: "Luis López De Castro Alonso",
      year: "2025",
      description: "Una mirada profunda a las competencias y habilidades que definen al abogado del siglo XXI.",
      amazon: "https://www.amazon.es/s?k=Luis+Lopez+De+Castro+Alonso",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/ixjnakyu_WhatsApp%20Image%202026-04-03%20at%2012.14.29.jpeg"
    },
    {
      title: "Más allá del litigio",
      author: "Luis López De Castro Alonso",
      year: "2025",
      description: "Estrategias para construir un despacho rentable sin depender exclusivamente del contencioso.",
      amazon: "https://www.amazon.es/s?k=Luis+Lopez+De+Castro+Alonso",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/vuba1xde_WhatsApp%20Image%202026-04-03%20at%2012.13.57.jpeg"
    },
    {
      title: "Abogados, estrategia y gestión",
      author: "Luis López De Castro Alonso",
      year: "2024",
      description: "Manual práctico sobre gestión estratégica de despachos de abogados.",
      amazon: "https://www.amazon.es/s?k=Luis+Lopez+De+Castro+Alonso",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/8ow315gb_1.jpeg"
    },
    {
      title: "La brújula del abogado",
      author: "Luis López De Castro Alonso",
      year: "2026",
      description: "Guía de orientación para abogados en un mundo profesional en constante cambio.",
      amazon: "https://www.amazon.es/s?k=Luis+Lopez+De+Castro+Alonso",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/i9s144vb_WhatsApp%20Image%202026-04-03%20at%2012.15.21.jpeg"
    },
    {
      title: "La década decisiva de las grandes firmas",
      author: "Luis López De Castro Alonso",
      year: "2025",
      description: "Análisis del futuro de los grandes despachos y las decisiones clave de esta década.",
      amazon: "https://www.amazon.es/s?k=Luis+Lopez+De+Castro+Alonso",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/6v62vpgy_WhatsApp%20Image%202026-04-03%20at%2012.14.14.jpeg"
    }
  ];

  const librosJoseLuis = [
    {
      title: "HACKIA TU DESPACHO",
      subtitle: "Guía Práctica de IA para Juristas",
      author: "José Luis Vilaplana",
      year: "2025",
      description: "Cómo Ángela y Sofía transformaron su despacho sin morir en el intento. La guía definitiva para implementar IA en el sector legal.",
      amazon: "https://amzn.eu/d/0gNI5a7u",
      featured: true
    },
    {
      title: "La nueva abogacía",
      subtitle: "Habilidades para liderar, convencer y triunfar",
      author: "José Luis Vilaplana",
      publisher: "Ed. Aranzadi La Ley",
      year: "2024",
      description: "Guía de habilidades para liderar, convencer y triunfar en la abogacía moderna.",
      amazon: "https://www.amazon.es/nueva-abogac%C3%ADa-habilidades-convencer-Monograf%C3%ADas/dp/8410789434?&linkCode=ll1&tag=tecnoabogad01-21&linkId=f359a97d312cdbfe55f0d9d771198945&language=es_ES&ref_=as_li_ss_tl"
    },
    {
      title: "La Ciencia del Acuerdo",
      subtitle: "Negociación, Psicología y Estrategia",
      author: "José Luis Vilaplana",
      publisher: "Ed. Aranzadi La Ley",
      year: "2025",
      description: "Negociación, Psicología y Estrategia para la abogacía actual.",
      amazon: "https://www.amazon.es/acuerdo-negociar-abogac%C3%ADa-Gersti%C3%B3n-Despachos/dp/8410851296?dplnkId=9f18a73f-671b-4036-8a9b-b58827d99c88&nodl=1&linkCode=ll1&tag=tecnoabogad01-21&linkId=c7277e2a79d41fd0f0f81d9f0fc63e2b&language=es_ES&ref_=as_li_ss_tl"
    }
  ];

  return (
    <section id="libros" className="bg-reset-black py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-reset-gold uppercase tracking-widest text-sm mb-4 block">
            Biblioteca Tecnoabogado
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-white leading-tight mb-6">
            <span className="italic text-reset-gold">Libros</span> de los expertos
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Obras de referencia sobre gestión de despachos, estrategia empresarial e inteligencia artificial aplicada al derecho.
          </p>
        </div>

        {/* Libros de Luis López De Castro */}
        <div className="mb-20">
          <h3 className="text-3xl font-semibold text-white mb-8 flex items-center gap-3">
            <BookOpen className="text-reset-gold" size={32} />
            Luis López De Castro Alonso
          </h3>
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
            {librosLuis.map((libro, index) => (
              <div 
                key={index}
                className="bg-reset-dark border border-reset-gold/20 p-4 hover:border-reset-gold/50 transition-all group"
              >
                <div className="aspect-[3/4] bg-reset-gray mb-4 overflow-hidden">
                  <img 
                    src={libro.image}
                    alt={libro.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
                <h4 className="text-white font-semibold mb-2 text-sm leading-tight">
                  {libro.title}
                </h4>
                <p className="text-gray-500 text-xs mb-3">{libro.year}</p>
                <p className="text-gray-400 text-xs mb-4 line-clamp-3">
                  {libro.description}
                </p>
                <a 
                  href={libro.amazon}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-reset-gold hover:text-reset-gold-light transition-colors text-sm"
                >
                  <ShoppingCart size={14} />
                  <span>Ver en Amazon</span>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Libros de José Luis Vilaplana */}
        <div>
          <h3 className="text-3xl font-semibold text-white mb-8 flex items-center gap-3">
            <BookOpen className="text-reset-gold" size={32} />
            José Luis Vilaplana (@tecnoabogado)
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {librosJoseLuis.map((libro, index) => (
              <div 
                key={index}
                className={`bg-reset-dark border ${
                  libro.featured 
                    ? 'border-reset-gold bg-reset-gold/5' 
                    : 'border-reset-gold/20'
                } p-6 hover:border-reset-gold/50 transition-all group relative`}
              >
                {libro.featured && (
                  <div className="absolute top-0 right-0 bg-reset-gold text-black px-3 py-1 text-xs font-bold">
                    NOVEDAD IA
                  </div>
                )}
                <div className="mb-4">
                  <h4 className="text-xl font-semibold text-white mb-1">
                    {libro.title}
                  </h4>
                  {libro.subtitle && (
                    <p className="text-reset-gold text-sm mb-2">{libro.subtitle}</p>
                  )}
                  {libro.publisher && (
                    <p className="text-gray-500 text-xs mb-2">{libro.publisher} • {libro.year}</p>
                  )}
                  {!libro.publisher && (
                    <p className="text-gray-500 text-xs mb-2">{libro.year}</p>
                  )}
                </div>
                <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                  {libro.description}
                </p>
                <a 
                  href={libro.amazon}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-reset-gold hover:bg-reset-gold-light text-black px-4 py-2 font-semibold transition-all"
                >
                  <ShoppingCart size={16} />
                  <span>Comprar en Amazon</span>
                  <ExternalLink size={14} />
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-16 text-center bg-reset-dark border border-reset-gold/20 p-8">
          <p className="text-gray-300 text-lg">
            ¿Quieres llevar tu despacho al siguiente nivel? <br />
            <span className="text-white font-semibold">Descubre nuestros programas de implementación</span>
          </p>
          <button 
            onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            className="mt-6 bg-reset-gold hover:bg-reset-gold-light text-black px-8 py-3 font-bold transition-all"
          >
            Solicitar información
          </button>
        </div>
      </div>
    </section>
  );
};

export default Libros;